/* עד מתי כל כרטיס וחשבון נסרק: התאריך האחרון שיש לו פעולה, לכל כרטיס (4 ספרות) ולעו"ש.
   הדוח הבא צריך להתחיל מהתאריך הזה. החפיפה של יום אחד מטופלת בזיהוי הכפילויות. */
import { S, memo } from './state.js';
import { todayISO, iso10 } from '../lib/format.js';
import { getTxSrc } from './tx.js';

export function scanCoverage() {
  return memo('scanCoverage', () => {
    const today = todayISO();
    const g = {};
    // בעו"ש יש גם פעולות ידניות. אם יש שורות שהגיעו מסריקה, רק הן נספרות
    const bankTagged = S.tx.some((t) => getTxSrc(t) === 'cash' && (t.raw_name || t.ref));
    S.tx.forEach((t) => {
      const ds = iso10(t.date);
      if (!ds || ds > today) return;
      let key;
      if (getTxSrc(t) === 'credit') key = t.card4 ? 'c:' + t.card4 : 'c:?';
      else {
        if (bankTagged && !(t.raw_name || t.ref)) return;
        key = 'b';
      }
      if (!g[key] || ds > g[key]) g[key] = ds;
    });
    const hasCards = Object.keys(g).some((k) => /^c:\d{4}$/.test(k));
    const out = [];
    Object.keys(g).forEach((k) => {
      if (k === 'c:?' && hasCards) return; // שורות ישנות בלי מספר כרטיס
      const label = k === 'b' ? '🏦 עו"ש' : k === 'c:?' ? '💳 אשראי' : '💳 כרטיס ' + k.slice(2);
      out.push({ key: k, label, date: g[k], src: k === 'b' ? 'cash' : 'credit', approx: k === 'b' && !bankTagged });
    });
    return out.sort((a, b) => (a.src === b.src ? a.label.localeCompare(b.label) : a.src === 'credit' ? -1 : 1));
  });
}
